/**
 * @file AdvisorSectionButton.js
 * @module src/js/components/AdvisorSectionButton
 * @description
 * **Component for advisor section action buttons (Edit, Save, Delete, Cancel).**
 * - Renders buttons to edit, save, delete, or cancel changes to advisor sections.
 * - Handles button states based on editing mode and updating status.
 * - Displays messages using the modal system.
 *
 * @version
 * <p>
 *  2025-12-02: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Migrate to useUpdateProfile hook and refactor. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { useLocation } from 'react-router-dom';

export default function AdvisorSectionButton({
    index,
    oneShowInput,
    setTitleRefToScrollIntoView,
    oneSectionData,
    updatedItem,
    oneUpdatedImgFile,
    updating,
    updateProfile,
    handleClickCancelEdit,
    withImage = true,
}) {
    const { pathname } = useLocation();

    const contentNotChanged = JSON.stringify(oneSectionData) === JSON.stringify(updatedItem);
    const imageNotUploaded = oneUpdatedImgFile == null;
    const isProfilePage = pathname === '/member-zone/profile';

    return (
        <ul className="actions special">
            <li>
                {/* Save button */}
                {isProfilePage && oneShowInput && (
                    <button
                        onClick={async () => {
                            await updateProfile({
                                request: '/api/advisor',
                                updatedProfileData: updatedItem,
                                updatedImgFile: oneUpdatedImgFile,
                                from: pathname,
                            });
                            setTitleRefToScrollIntoView(index);
                        }}
                        style={{ marginTop: '15px' }}
                        disabled={
                            (contentNotChanged &&
                            (!withImage || imageNotUploaded)) ||
                            updatedItem.title === '' ||
                            updatedItem.text === '' ||
                            updating
                        }
                        // Check oneUpdatedImgFile === null instead of comparing names
                        // because the updated image name may be the same as the original one
                    >
                        Save
                    </button>
                )}

                {/* Edit / Cancel button */}
                {isProfilePage && (
                    <button
                        onClick={() => handleClickCancelEdit(index, withImage)}
                        style={{ marginTop: '15px', marginLeft: '15px', marginRight: '15px' }}
                        disabled={updating}
                    >
                        {oneShowInput ? 'Cancel' : 'Edit'}
                    </button>
                )}

                {/* Delete button */}
                {isProfilePage && !oneShowInput && (
                    <button
                        onClick={() => {
                            updateProfile({
                                request: `/api/advisor/${oneSectionData.advisorID}`,
                                deleteSection: true,
                                from: pathname,
                            });
                        }}
                        style={{
                            marginTop: '15px',
                            color: 'lightcoral',
                            outline: '2px solid lightcoral',
                            outlineOffset: '-2px',
                        }}
                        disabled={updating}
                    >
                        Delete
                    </button>
                )}
            </li>
        </ul>
    );
}